var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99902 3C10.6657 3 11.3324 3.25333 11.999 3.76C12.6657 3.25333 13.3324 3 13.999 3H19.999C20.5295 3 21.0382 3.21071 21.4132 3.58579C21.7883 3.96086 21.999 4.46957 21.999 5V18C21.999 18.5304 21.7883 19.0391 21.4132 19.4142C21.0382 19.7893 20.5295 20 19.999 20H12.999C12.999 20.552 12.549 21 11.999 21C11.449 21 10.999 20.55 10.999 20H3.99902C3.46859 20 2.95988 19.7893 2.58481 19.4142C2.20974 19.0391 1.99902 18.5304 1.99902 18V5C1.99902 4.46957 2.20974 3.96086 2.58481 3.58579C2.95988 3.21071 3.46859 3 3.99902 3H9.99902ZM9.99902 5H3.99902V18H10.999V6C10.999 5.45 10.549 5 9.99902 5ZM19.999 5H13.999C13.449 5 12.999 5.45 12.999 6V18H19.999V5Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/Book.c43866cd62e1fb90589aa25e82146b3f.svg";
export { ForwardRef as ReactComponent };